import teamListStore from '@modules/team/team-list-store';
import teamViewStore from '@modules/team/team-view-store';
import teamImporterStore from '@modules/team/team-importer-store';
import teamFormStore from '@modules/team/team-form-store';
import teamDestroyStore from '@modules/team/team-destroy-store';
import teamListTransferStore from '@modules/team/team-list-transfer-store';


export default {
  namespaced: true,

  modules: {
    destroy: teamDestroyStore,
    form: teamFormStore,
    list: teamListStore,
    listTransfer: teamListTransferStore,
    view: teamViewStore,
    importer: teamImporterStore,
  },
};
